$(document).ready(function () {
    // psemailsubscription_subscription+='?XDEBUG_SESSION=start';
    $('.block_newsletter form').on('submit', function () {
        let psemailsubscriptionForm = $(this);
        if (typeof psemailsubscription_subscription === 'undefined') {
            return true;
        }
         

        let inp =$(this).find('input').first();
        inp.addClass('disabled').attr('disabled','disabled');
         
        $('.block_newsletter_alert').remove();

        $.ajax({
            type: 'POST',
            dataType: 'JSON',
            url: psemailsubscription_subscription,
            cache: false,
            data: $(this).serialize(),
            success: function (data) {
                if (data.nw_error) {
                    psemailsubscriptionForm.prepend('<p class="alert alert-danger block_newsletter_alert">' + data.msg + '</p>');
                    inp.removeClass('disabled').removeAttr('disabled');
                } else {
                    psemailsubscriptionForm.prepend('<p class="alert alert-success block_newsletter_alert">' + data.msg + '</p>');
                }
            },
            error: function (err) {
                inp.removeClass('disabled').removeAttr('disabled');
                console.log(err);
            }
        });
        return false;
    });
});

document.addEventListener('DOMContentLoaded',()=>{
    let email= document.querySelector('.block_newsletter [name=email]');
    console.log("LS: init newsletter checkbox " );
    if(!email) return;

    let field =email.form.querySelector('.custom-checkbox');
    if(!field) return;

    field.style.display='none';

    email.addEventListener('focus',()=>{
        field.style.display='block';
    });
})